import React from 'react'
import { Dropdown, Menu } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import * as DROPDOWN from 'constant/dropdown'
import PropTypes from 'prop-types'
import EditSite from 'view/page/site-management/component/edit-site'
import NewPermittedGroup from 'view/page/site-management/component/new-permitted-group'
import OrderCategories from 'view/page/site-management/component/order-categories'
import formatInputs from 'helper/format-input-fields'
import styles from './styles'

const Action = ({ site }) =>
  (<span>
    <Dropdown
      overlay={
        <Menu >
          <Menu.Item>
            <EditSite site={formatInputs(site)} />
          </Menu.Item>
          <Menu.Item>
            <OrderCategories site={formatInputs(site)} />
          </Menu.Item>
          <Menu.Item>
            <NewPermittedGroup siteUuid={site.uuid} />
          </Menu.Item>
        </Menu>
      }
      overlayStyle={{ zIndex: 1 }}
      trigger={[DROPDOWN.TRIGGER]}
    >
      <div className={styles.show_more}>
        <span>More</span>
        <DownOutlined />
      </div>
    </Dropdown>
  </span>)

Action.propTypes = {
  site: PropTypes.object
}

export default Action
